import { Mover } from './api.service';

/**
 * DEV-7522: turn the ask-prematch reply into a mover list, or null when it is not one.
 *
 * The WordPress proxy answers 200 even when the ERP behind it fails, and passes the
 * ERP's body through as a string: a Laravel "Server Error" HTML page, or an empty one.
 * JSON.parse threw on that inside the next callback, so the error callback never ran:
 * the consent step stayed enabled and was shown without any movers, and the throw
 * reached Bugsnag as an unhandled error. Returning null lets the caller treat it
 * exactly like a failed request.
 */
export function parsePrematchMovers( movers: unknown ): Mover[] | null {

	let parsed = movers;

	if( typeof movers === 'string' ) {

		try {
			parsed = JSON.parse( movers );
		}
		catch {
			return null;
		}
	}

	return Array.isArray( parsed ) ? parsed : null;
}
